import React, { memo, useMemo } from 'react';
import lodash from 'lodash';
import DefaultMaterialTable from 'common/util/materialTable';
import { optionsBuilder } from 'common/util/materialTable/options';
import {
    renderColumns,
    reportDefaultColumns,
} from '../utils/reportUtils';
import { DEFAULT_OFFSET, DEFAULT_DEBOUNCE_INTERVAL } from '../utils/constants';

const ReportContentTable = ({
    reportType,
    tableTheme,
    totalCount,
    reportFilters,
    reportData,
    columns,
    onChangeReportFilters,
    localization
}) => {
    const { limit, offset } = reportFilters;
    const page = offset / limit;

    const options = optionsBuilder({
        search: false,
        filtering: true,
        toolbar: false,
        pageSize: limit,
        debounceInterval: DEFAULT_DEBOUNCE_INTERVAL,
    });

    const memoizedColumns = useMemo(() => renderColumns(reportType, columns, reportFilters),[columns, reportFilters]);

    const onChangeRowsPerPage = limit => onChangeReportFilters({ limit });

    const onChangePage = (page, pageSize) => {
        const offset = page * pageSize;
        onChangeReportFilters({ offset });
    };

    const onOrderChange = (orderBy, orderDirection) => {
        const body = {
            sortField: orderBy === -1 ? '' : reportDefaultColumns(reportType)[orderBy],
            sortType: orderBy === -1 ? '' : orderDirection,
            offset: DEFAULT_OFFSET,
        };
        onChangeReportFilters(body);
    };

    const onFilterChange = filterList => {
        const filters = filterList.reduce((result, item) => {
            const {
                column: { field },
                value,
            } = item;
            if(lodash.isEmpty(value)){
                return result;
            }
            return [
                ...result,
                {
                    fieldName: field,
                    value,
                },
            ];
        }, []);

        onChangeReportFilters({ offset: DEFAULT_OFFSET, filters });
    };

    return (
        <DefaultMaterialTable
            key={reportType}
            theme={tableTheme}
            options={options}
            columns={memoizedColumns}
            data={reportData}
            page={page}
            totalCount={totalCount}
            onChangeRowsPerPage={onChangeRowsPerPage}
            onChangePage={onChangePage}
            onOrderChange={onOrderChange}
            onFilterChange={onFilterChange}
            localization={localization}
            data-cy="ReportTable"
        />
    );
};

export default memo(ReportContentTable);
